import { EnumLiteralsOf } from '../types/helpers'

export const FormTypes = {
  EDIT: 'edit',
  NEW: 'new',
  MANUAL: 'manual',
} as const

export type FormType = EnumLiteralsOf<typeof FormTypes>
